import { render, staticRenderFns } from "./FormNumberField.vue?vue&type=template&id=139966de&"
import script from "./FormNumberField.vue?vue&type=script&lang=ts&"
export * from "./FormNumberField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports